export const ACTION_TYPES = {
  SET_ERROR: '@ERROR/SET_ERROR'
};
